import { enforce, omitWhen, test } from 'vest';

import { withDefaults } from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface ApaleoService {
  clientId: string;
  clientSecret: string;
  propertyIds: string[];
  checkInEvent: '' | 'unit-assigned';
}

export const APALEO_CHECK_IN_EVENTS = ['', 'unit-assigned'];

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    clientId: '',
    clientSecret: '',
    propertyIds: [],
    checkInEvent: '',
  },
  features: {},
  cron: [],
  webhooks: [],
});

export const apaleo: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig.service as unknown as ApaleoService;

    test(`${SERVICE}.clientId`, t('validations.required'), () => {
      enforce(service.clientId).isNotBlank();
    });

    test(`${SERVICE}.clientSecret`, t('validations.required'), () => {
      enforce(service.clientSecret).isNotBlank();
    });

    test(`${SERVICE}.propertyIds`, t('validations.required'), () => {
      const propertyIds = Array.isArray(service.propertyIds)
        ? service.propertyIds
        : [];

      enforce(propertyIds).isNotEmpty();
      enforce(propertyIds.every((id) => Boolean(id?.trim()))).isTruthy();
    });

    omitWhen(!service.checkInEvent, () => {
      test(`${SERVICE}.checkInEvent`, t('validations.invalid'), () => {
        enforce(service.checkInEvent).inside(APALEO_CHECK_IN_EVENTS);
      });
    });
  },
};
